import { render, staticRenderFns } from "./CasinoHataIslemleri.vue?vue&type=template&id=224edfc0&scoped=true"
import script from "./CasinoHataIslemleri.vue?vue&type=script&lang=js"
export * from "./CasinoHataIslemleri.vue?vue&type=script&lang=js"
import style0 from "./CasinoHataIslemleri.vue?vue&type=style&index=0&id=224edfc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224edfc0",
  null
  
)

export default component.exports